import service from '@/services/delivery-fee/DeliveryFeeService'

export const deliveryFeeModule = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    deliveryFeeList: [],
    loadingItems: false,
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
    },
  },
  mutations: {
    SET_LIST(state, payload) {
      if (payload.current_page) {
        state.pagination.current_page = payload.current_page
        state.pagination.last_page = payload.last_page
      }
      state.deliveryFeeList = payload.data ?? payload
    },
    SET_LOADING(state) {
      state.loadingItems = !state.loadingItems
    },
  },
  actions: {
    async getDeliveryFees({ commit }, payload) {
      try {
        commit('SET_LOADING')
        let response = await service.getDeliveryFees(payload)
        commit('SET_LIST', response)
      } finally {
        commit('SET_LOADING')
      }
    },
    async getDeliveryFee(context, payload) {
      let data = await service.getDeliveryFee(payload)

      return data
    },
    async insertDeliveryFee({ dispatch, state }, payload) {
      let request = service.translateToFirebird(payload)
      const { status } = await service.insert(request)

      dispatch('getDeliveryFees', {
        page: state.pagination.current_page,
      })

      return status
    },

    async updateDeliveryFee({ dispatch, state }, payload) {
      let request = service.translateToFirebird(payload)
      const { status } = await service.update(request, payload.id)

      dispatch('getDeliveryFees', {
        page: state.pagination.current_page,
      })

      return status
    },

    async deleteDeliveryFee({ dispatch, state }, payload) {
      const { status } = await service.delete(payload)

      dispatch('getDeliveryFees', {
        page: state.pagination.current_page,
      })

      return status
    },
  },
  getters: {
    getComboBoxList: (state) => {
      return state.deliveryFeeList
        ? state.deliveryFeeList.map((deliveryFee) => deliveryFee.DESCRICAO)
        : []
    },
    getDeliveryFeeList: (state) => {
      return state.deliveryFeeList
    },
  },
}
